import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { claimUpload } from "@/lib/api";

/**
 * AuthCallback handles `#session_id=...` from Emergent OAuth, exchanges it
 * via backend, and navigates to the original `next` path.
 */
export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const processedRef = useRef(false);
    const [err, setErr] = useState(null);

    useEffect(() => {
        if (processedRef.current) return;
        processedRef.current = true;

        const run = async () => {
            const hash = window.location.hash || "";
            const m = hash.match(/session_id=([^&]+)/);
            const session_id = m ? decodeURIComponent(m[1]) : null;

            // next path can be in query of the host URL
            const sp = new URLSearchParams(location.search);
            const next = sp.get("next") || "/dashboard";
            const upload_id = sp.get("upload_id");
            const referral_from =
                sp.get("ref") ||
                (typeof window !== "undefined"
                    ? localStorage.getItem("bl_referral_share_token")
                    : null);

            if (!session_id) {
                navigate("/auth/login");
                return;
            }
            try {
                await api.post("/auth/session", {
                    session_id,
                    referral_from: referral_from || undefined,
                });
                try {
                    localStorage.removeItem("bl_referral_share_token");
                } catch { /* non-critical */ }
                if (upload_id) {
                    try {
                        await claimUpload(upload_id);
                    } catch { /* non-critical */ }
                }
                // clean URL
                window.history.replaceState(null, "", next);
                await refresh();
                navigate(next, { replace: true });
            } catch (e) {
                setErr("Sign-in failed. Please try again.");
                setTimeout(() => navigate("/auth/login"), 1500);
            }
        };
        run();
    }, [navigate, location, refresh]);

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-bl-bg"
            data-testid="auth-callback"
        >
            <div className="bl-card p-10 text-center">
                <div className="bl-spinner mx-auto" />
                <p className="mt-5 text-bl-muted">
                    {err || "Finishing sign-in…"}
                </p>
            </div>
        </div>
    );
}
